import { render, staticRenderFns } from "./LeiComentada.vue?vue&type=template&id=775f18fc&scoped=true"
import script from "./LeiComentada.vue?vue&type=script&lang=js"
export * from "./LeiComentada.vue?vue&type=script&lang=js"
import style0 from "./LeiComentada.vue?vue&type=style&index=0&id=775f18fc&prod&lang=scss&scoped=true"
import style1 from "./LeiComentada.vue?vue&type=style&index=1&id=775f18fc&prod&lang=scss&scoped=true"
import style2 from "./LeiComentada.vue?vue&type=style&index=2&id=775f18fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f18fc",
  null
  
)

export default component.exports